import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  signal,
} from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import {
  EmperorButtonModule,
  EmperorUIButtonTypes,
} from '@boldpenguin/emperor-presentational';
import { getFormId } from '@boldpenguin/sdk';
import { BpSdkStoreService } from 'src/app/core/services/bp-sdk-store-service/bp-sdk-store.service';
import { ApplicationFormDebugTabComponent } from './application-form-debug-tab/application-form-debug-tab.component';
import { QuotesDebugTabComponent } from './quotes-debug-tab/quotes-debug-tab.component';
import { TerminalDebugTabComponent } from './terminal-debug-tab/terminal-debug-tab.component';

@Component({
  selector: 'app-debug-drawer',
  templateUrl: './debug-drawer.component.html',
  styleUrls: ['./debug-drawer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    ApplicationFormDebugTabComponent,
    EmperorButtonModule,
    MatTabsModule,
    QuotesDebugTabComponent,
    TerminalDebugTabComponent,
  ],
})
export class DebugDrawerComponent {
  readonly emperorButtonTypes = EmperorUIButtonTypes;

  private readonly sdkStoreService = inject(BpSdkStoreService);

  isOpen = signal(false);

  hasApplicationForm = computed(() => {
    const sdkState = this.sdkStoreService.sdkReadyState();
    return !!sdkState && !!getFormId(sdkState);
  });

  toggle(): void {
    this.isOpen.update((isOpen) => !isOpen);
  }
}
